import { Component, Input } from '@angular/core';

@Component({
  selector: 'nrwl-common-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})

export class AboutComponent {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() dataSource: any;
}
